import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {SplitText} from 'gsap/SplitText';
import {CustomEase} from 'gsap/CustomEase';

gsap.registerPlugin( ScrollTrigger, SplitText, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      // heading animations only applies to hdg-3 and hdg-2 heading style sizes
      const slideClasses = '.js-slide-group > .hdg-3, .js-slide-group > .hdg-2, .hdg-3.js-slide, .hdg-2.js-slide';
      new SplitText( slideClasses, {type: 'lines', linesClass: 'line-wrap', tag: 'span'} );
      new SplitText( '.line-wrap', {type: 'lines', linesClass: 'line', tag: 'span'} );

      document.querySelectorAll( 'section' ).forEach( ( el ) => {
        const section = gsap.utils.selector( el );
        const sectArray = section( '.js-slide:not(.js-ignore, [class*=hdg-]), .js-slide-group > *:not(.js-ignore, [class*=hdg-]), .line, .js-fade' );

        const items = sectArray;
        if ( items.length > 0 ) {
          el.style.setProperty( '--item-total', items.length );
          sectArray.map( ( line, index ) => line.style.setProperty( '--item-index', index ) );
        }
      } );

      $( '.js-slide:not(.js-ignore), .js-slide-group > *:not(.js-ignore)' ).each( function() {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top 90%',
          scrub: 0.15,
          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( this ).addClass( 'js-animated' );
            }
          },
          onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
        } );
      } );

      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
          gsap.set( elements, startAnimationObj );

          const triggers = ScrollTrigger.batch( elements, {
            toggleClass: 'js-animated',
            once: true,
            start: start,
            onEnter: ( batch ) => {
              animationFunction( batch );
            },
          } );

          ScrollTrigger.addEventListener( 'refreshInit', () => {
            triggers.forEach( ( trigger ) => {
              if ( trigger.progress > 0 ) {
                animationFunction( trigger.trigger );
              }
            } );
          } );
        }
      }


      // global animations in animate will load in after running common.js init function, all component javascript, and before common.js finalize function.
      // This should improve animations loading in and fix odd start times due to load order
      /*
       * Fade on scroll
       */
      const fadeUpClasses = '.js-fade:not(.js-ignore, .hdg-2, .hdg-3), .js-fade-group > *:not(.js-ignore, .hdg-2, .hdg-3)';

      const fadeUpHeadingClasses = '.js-fade:is(.hdg-2, .hdg-3):not(.js-ignore), .js-fade-group > :is(.hdg-2, .hdg-3):not(.js-ignore)';

      new SplitText( fadeUpHeadingClasses, {type: 'lines', linesClass: 'line-wrap', tag: 'span'} );
      new SplitText( '.line-wrap', {type: 'lines', linesClass: 'line', tag: 'span'} );

      function fadeUpTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        /* Opacity style and transitions */
        tl.to( elements, {
          duration: 0.35, // duration e.g. 0.8s
          autoAlpha: 1,
          ease: '0.25,0.1,0.25,1', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          y: 0, // property/value
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fadeUpClasses, {autoAlpha: 0, y: 25}, fadeUpTimeline );

      function slideUp( elements ) {
        gsap.to( elements,
            {
              yPercent: 0, // property/value
              duration: 0.8, // duration e.g. 1s
              ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
              stagger: 0.1, // delay e.g 0.1s
            },
        );
      }

      createAnimation( '.line', {yPercent: 100}, slideUp );

      /*
       * Reveal on scroll
       */
      function reveal( elements ) {
        gsap.to( elements,
            {
              clipPath: 'inset(0% 0% 0% 0%)',
              duration: 1.5,
              ease: '0, 0, 0.58, 1.0',
              stagger: 0.2, // delay e.g 0.2s
            },
        );
      }

      const revealRightClasses = '.js-reveal-right:not(.js-ignore)';
      createAnimation( revealRightClasses, {clipPath: 'inset(0 100% 0 0)'}, reveal );

      const revealLeftClasses = '.js-reveal-left:not(.js-ignore)';
      createAnimation( revealLeftClasses, {clipPath: 'inset(0 0 0 100%)'}, reveal );
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
